import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Heading, Card } from 'components/chroma';
import { TextSmall } from 'components/chroma/extended';
import { Superscript } from 'components/Superscript';
import ICONS from 'components/Icons';
import { InsuranceName } from 'scenes/common/types';

const CardContentContainer = styled.div`
  padding: 1em 2em 0 2em;
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  h3 {
    margin-left: 1em;
    margin-bottom: 0;
  }
`;

const LogoImage = styled.img`
  height: 91px;
`;

const FlybuysInfoCard: FunctionComponent<{
  insuranceName: InsuranceName;
}> = ({ insuranceName }) => (
  <Card>
    <CardContentContainer>
      <HeaderWrapper>
        <LogoImage
          src={ICONS.LOGO.FLYBUYS}
          tabIndex={-1}
          alt="Flybuys graphic"
        />
        <Heading size={3}>Reward yourself with Flybuys</Heading>
      </HeaderWrapper>
      <TextSmall weight={400} margin={{ top: 4 }}>
        Get 2 Flybuys points per $1 dollar spent at Coles Supermarkets when
        you’re a Coles{' '}
        {insuranceName === InsuranceName.Car ? 'Comprehensive' : ''}{' '}
        {insuranceName} Insurance customer – that’s up to 12,000 points or up to
        $60 of value per policy per year.
        <Superscript>#</Superscript>
      </TextSmall>
    </CardContentContainer>
  </Card>
);

export const FlybuysInfoSection: FunctionComponent<{
  insuranceName: InsuranceName;
}> = ({ insuranceName }) => (
  <>
    <FlybuysInfoCard insuranceName={insuranceName} />
    <TextSmall weight={200} margin={{ top: 4 }}>
      <Superscript>#</Superscript> Flybuys members collect 1 Flybuys point for
      every dollar spent at Coles Supermarkets whenever they scan their Flybuys
      card. Flybuys members with Coles Comprehensive Car, Home or Landlord
      Insurance policies (Coles Insurance Policies) collect +1 extra point on
      each dollar spent at Coles Supermarkets for each policy whenever they scan
      their Flybuys card. Maximum 1,000 extra points per policy per month.
      Flybuys extra points are collected from the date your Flybuys membership
      is linked to your Coles Insurance policy and for the term of the policy.
      No extra points collected on any third party car insurance policies. No
      Flybuys extra points will be collected for the month in which your policy
      terminates. Standard Flybuys Terms and Conditions apply. Flybuys extra
      points are collected on transaction balance after savings and discounts
      excluding gift cards, iTunes cards, tobacco and tobacco related purchases.
      Coles supermarkets means Coles Supermarkets and Coles Online only.
    </TextSmall>
  </>
);

export default FlybuysInfoSection;
